import { nanoid } from 'nanoid';

import type {
  CreateTrashLogFormValues,
  TrashLog,
  TrashLogEntry,
  UpdateTrashLogFormValues,
} from '@/store/trash-log/trash-log.dto';

import type { TrashEntry, TrashLogState } from './types';

const entryToDto = (entry: TrashEntry): TrashLogEntry => ({
  dateTime: entry.dateTime,
  positionRemarks: entry.positionRemarks,
  category: entry.category,
  estimatedAmount: entry.estimatedAmount,
  toSea: entry.toSea,
  toReceptionFacility: entry.toReceptionFacility,
  incineration: entry.incineration,
  certificationSignature: entry.certificationSignature,
});

const entryFromDto = (entry: TrashLogEntry): TrashEntry => ({
  id: nanoid(),
  dateTime: entry.dateTime,
  positionRemarks: entry.positionRemarks,
  category: entry.category,
  estimatedAmount: entry.estimatedAmount,
  toSea: entry.toSea,
  toReceptionFacility: entry.toReceptionFacility,
  incineration: entry.incineration,
  certificationSignature: entry.certificationSignature,
});

export const trashLogToFormState = (log: TrashLog): TrashLogState => ({
  date: log.date,
  entries: log.entries.map(entryFromDto),
});

export const formStateToCreateValues = (state: TrashLogState): CreateTrashLogFormValues => ({
  date: state.date,
  entries: state.entries.map(entryToDto),
});

export const formStateToUpdateValues = (
  id: string,
  state: TrashLogState,
): UpdateTrashLogFormValues => ({
  id,
  entries: state.entries.map(entryToDto),
});
